import { useContext, useMemo } from 'react';
import { LabelVariantsContext } from './labelVariantsContext';
import { NestedObject } from './types';

const getNestedObjectValue = (obj: NestedObject, key: string): string | undefined => {
  const keys = key.split('.');
  let currentObj: NestedObject | any = obj;

  for (const k of keys) {
    if (Object.prototype.hasOwnProperty.call(currentObj, k)) {
      currentObj = currentObj[k];
    } else {
      return undefined;
    }
  }

  return currentObj;
};

const useLabelVariants = (nameSpace?: string) => {
  const ctx = useContext<any>(LabelVariantsContext);
  return useMemo(
    () => ({
      v: (labelKey: string) => {
        const value = nameSpace ? getNestedObjectValue(ctx, `${nameSpace}.${labelKey}`) : ctx?.[labelKey];
        return value ?? '';
      },
    }),
    [ctx, nameSpace],
  );
};

export default useLabelVariants;
